import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import configureStore from './store/configure-store';
import tokenHelpers from './helpers/token';
import App from './App';
import SignUp from './containers/SignUp';
import SignIn from './containers/SignIn';
import ForgotPassword from './containers/ForgotPassword';
import ResetPassword from './containers/ResetPassword';
import './index.css';

const store = configureStore();

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
      <Component {...props}/>
  )}/>
)

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <PrivateRoute path="" component={App}/>
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/